/**
 * @generated SignedSource<<3ee2a2294ccc0d5f17165121abe01d7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type TodoStatus = "DONE" | "PENDING";
export type TeamQuery$variables = {
  after?: string | null;
  employeeId?: string | null;
  first?: number | null;
  isEmployee: boolean;
  status?: TodoStatus | null;
  teamId: string;
};
export type TeamQuery$data = {
  readonly store: {
    readonly employee?: {
      readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
    } | null;
    readonly me?: {
      readonly employee: {
        readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
      } | null;
      readonly user: {
        readonly " $fragmentSpreads": FragmentRefs<"Avatar_user">;
      };
    } | null;
    readonly myRole: Roles;
    readonly team: {
      readonly defaultTodoCategory: {
        readonly " $fragmentSpreads": FragmentRefs<"TeamDefaultTodoCategory_TodoCategoryTeam">;
      } | null;
      readonly id: string;
      readonly name: string;
      readonly urgentSignals: ReadonlyArray<{
        readonly __typename: "Signal";
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"TeamFeatureBar_team" | "TeamTeamSchedulePreview_team" | "TeamTeamSchedule_team" | "TeamUrgentSignals_team">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"usePermissions_store">;
  };
  readonly viewer: {
    readonly appInfo: {
      readonly __typename: "AppInfo";
      readonly " $fragmentSpreads": FragmentRefs<"TeamAppInfoButton_appInfo">;
    } | null;
  } | null;
};
export type TeamQuery = {
  response: TeamQuery$data;
  variables: TeamQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEmployee"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "myRole",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "employeeId"
  }
],
v9 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "Avatar_employee"
  }
],
v10 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "includeInlineRoutines",
    "value": true
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "calculateNotCompletedStarted",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaskExecutionCount",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlExpiresAt",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageSize",
  "kind": "LinkedField",
  "name": "sizes",
  "plural": true,
  "selections": [
    (v22/*: any*/),
    (v23/*: any*/),
    (v11/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbhash",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrg",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgIconUri",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "descriptionFiles",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    (v24/*: any*/),
    (v12/*: any*/),
    (v15/*: any*/),
    (v28/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkedToViewer",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v34 = [
  (v11/*: any*/),
  (v27/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageSize",
    "kind": "LinkedField",
    "name": "sizes",
    "plural": true,
    "selections": [
      (v11/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/)
    ],
    "storageKey": null
  }
],
v35 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v34/*: any*/),
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedAt",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedEmployee",
  "kind": "LinkedField",
  "name": "assigned",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        (v32/*: any*/),
        (v12/*: any*/),
        (v33/*: any*/),
        (v35/*: any*/)
      ],
      "storageKey": null
    },
    (v36/*: any*/)
  ],
  "storageKey": null
},
v38 = [
  (v11/*: any*/)
],
v39 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v35/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "EmployeeRole",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/),
    (v32/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employeeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": (v38/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employees",
      "plural": true,
      "selections": (v39/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedRole",
  "kind": "LinkedField",
  "name": "assignedRoles",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    (v40/*: any*/)
  ],
  "storageKey": null
},
v42 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "TIME_ONLY"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"TIME_ONLY\")"
  }
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "startAtDate",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "deadlineAtDate",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expireAt",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineAt",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueCount",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedTaskExecutionCount",
  "storageKey": null
},
v50 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isScheduledOccasion"
},
v51 = [
  (v6/*: any*/),
  (v11/*: any*/)
],
v52 = [
  (v11/*: any*/),
  (v17/*: any*/),
  {
    "alias": null,
    "args": (v18/*: any*/),
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      (v6/*: any*/),
      (v11/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v20/*: any*/),
          (v21/*: any*/)
        ],
        "type": "RoutineOccasion",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskExecutionCheck",
            "kind": "LinkedField",
            "name": "taskExecution",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "routineOccasion",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "TeamScheduleInlineRoutineOccasion",
        "abstractKey": null
      }
    ],
    "storageKey": "events(includeInlineRoutines:true)"
  }
],
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notResolvedCount",
  "storageKey": null
},
v54 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  }
],
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasHighPrioritySignals",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v58 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Literal",
    "name": "includeNewlyCompleted",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  }
],
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v34/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "style",
      "value": "DEFAULT"
    }
  ],
  "kind": "ScalarField",
  "name": "storeFormattedDate",
  "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
},
v63 = [
  (v62/*: any*/)
],
v64 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isActor"
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v35/*: any*/),
    (v33/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v66 = [
  (v12/*: any*/),
  (v11/*: any*/)
],
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v66/*: any*/),
  "storageKey": null
},
v68 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastScreen",
      "kind": "LinkedField",
      "name": "screen",
      "plural": false,
      "selections": (v66/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ScreenActor",
  "abstractKey": null
},
v69 = [
  (v65/*: any*/)
],
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": (v66/*: any*/),
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifyingName",
  "storageKey": null
},
v72 = [
  (v35/*: any*/),
  (v33/*: any*/),
  (v12/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": {
      "throwOnFieldError": true
    },
    "name": "TeamQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AppInfo",
            "kind": "LinkedField",
            "name": "appInfo",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamAppInfoButton_appInfo"
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "usePermissions_store"
          },
          {
            "condition": "isEmployee",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "Employee",
                "kind": "LinkedField",
                "name": "employee",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isEmployee",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreUser",
                "kind": "LinkedField",
                "name": "me",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "Avatar_user"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Employee",
                    "kind": "LinkedField",
                    "name": "employee",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamTeamSchedule_team"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamTeamSchedulePreview_team"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamFeatureBar_team"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamUrgentSignals_team"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Signal",
                "kind": "LinkedField",
                "name": "urgentSignals",
                "plural": true,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategoryTeam",
                "kind": "LinkedField",
                "name": "defaultTodoCategory",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TeamDefaultTodoCategory_TodoCategoryTeam"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AppInfo",
            "kind": "LinkedField",
            "name": "appInfo",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "linkURL",
                "storageKey": null
              },
              (v15/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "myPermissions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v16/*: any*/),
              {
                "alias": "dailySchedule",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "freq",
                    "value": "DAILY"
                  }
                ],
                "concreteType": "TeamSchedule",
                "kind": "LinkedField",
                "name": "currentTeamSchedule",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": (v18/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "events",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v11/*: any*/),
                      (v19/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isTeamScheduleEventOccasion"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v20/*: any*/),
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Routine",
                            "kind": "LinkedField",
                            "name": "routine",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "descriptionImages",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v11/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v11/*: any*/),
                              (v13/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v37/*: any*/),
                          (v41/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/)
                        ],
                        "type": "RoutineOccasion",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskExecutionCheck",
                            "kind": "LinkedField",
                            "name": "taskExecution",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RoutineOccasion",
                                "kind": "LinkedField",
                                "name": "routineOccasion",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Routine",
                                    "kind": "LinkedField",
                                    "name": "routine",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "descriptionImages",
                                        "plural": true,
                                        "selections": (v51/*: any*/),
                                        "storageKey": null
                                      },
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v37/*: any*/),
                                  (v41/*: any*/),
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Store",
                                    "kind": "LinkedField",
                                    "name": "store",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v48/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "notDoneStatus",
                                    "storageKey": null
                                  },
                                  (v49/*: any*/),
                                  (v46/*: any*/),
                                  (v19/*: any*/),
                                  (v47/*: any*/),
                                  (v50/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskCheck",
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": (v38/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sectionId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Routine",
                                "kind": "LinkedField",
                                "name": "routine",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v13/*: any*/),
                                  (v28/*: any*/),
                                  (v14/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "descriptionImages",
                                    "plural": true,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v31/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "checkValue",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "TeamScheduleInlineRoutineOccasion",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoreZonedDate",
                            "kind": "LinkedField",
                            "name": "endAtDate",
                            "plural": false,
                            "selections": (v42/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "TeamScheduleOneOffEvent",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": "events(includeInlineRoutines:true)"
                  }
                ],
                "storageKey": "currentTeamSchedule(freq:\"DAILY\")"
              },
              {
                "alias": "weeklySchedule",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "freq",
                    "value": "WEEKLY"
                  }
                ],
                "concreteType": "TeamSchedule",
                "kind": "LinkedField",
                "name": "currentTeamSchedule",
                "plural": false,
                "selections": (v52/*: any*/),
                "storageKey": "currentTeamSchedule(freq:\"WEEKLY\")"
              },
              {
                "alias": "monthlySchedule",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "freq",
                    "value": "MONTHLY"
                  }
                ],
                "concreteType": "TeamSchedule",
                "kind": "LinkedField",
                "name": "currentTeamSchedule",
                "plural": false,
                "selections": (v52/*: any*/),
                "storageKey": "currentTeamSchedule(freq:\"MONTHLY\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "features",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v11/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TodoCategoryTeam",
                        "kind": "LinkedField",
                        "name": "todoCategoryTeam",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v53/*: any*/),
                          {
                            "alias": null,
                            "args": (v54/*: any*/),
                            "kind": "ScalarField",
                            "name": "todoActiveAssignedCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasExpiredTodos",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "todoHighestPrio",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TodoCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v13/*: any*/),
                              (v55/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TodoCategoryTeamFeature",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "if": null,
                        "kind": "Defer",
                        "label": "TeamFeatureBar_team$defer$TeamFeatureBarSignalItem_team",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unreadCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activeCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v54/*: any*/),
                            "kind": "ScalarField",
                            "name": "signalUnreadCount",
                            "storageKey": null
                          },
                          (v56/*: any*/)
                        ]
                      }
                    ],
                    "type": "SignalTeamFeature",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Routine",
                        "kind": "LinkedField",
                        "name": "KPIRoutines",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                              }
                            ],
                            "concreteType": "RoutineOccasionConnection",
                            "kind": "LinkedField",
                            "name": "occasions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RoutineOccasionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoutineOccasion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Variable",
                                            "name": "teamId",
                                            "variableName": "teamId"
                                          }
                                        ],
                                        "concreteType": "RoutineOccasionSection",
                                        "kind": "LinkedField",
                                        "name": "occasionSections",
                                        "plural": true,
                                        "selections": [
                                          (v11/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "taskExecutions",
                                            "plural": true,
                                            "selections": [
                                              (v6/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isCompleted",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "TaskExecutionNumber",
                                                "abstractKey": null
                                              },
                                              (v11/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "occasions(first:1)"
                          },
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "KPITeamFeature",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "if": null,
                        "kind": "Defer",
                        "label": "TeamFeatureBar_team$defer$TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature",
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasExpiredBatches",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPendingActions",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "ProductDateTrackerTeamFeature",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeSignalCount",
                    "storageKey": null
                  },
                  (v56/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unreadSignalCount",
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Signal",
                "kind": "LinkedField",
                "name": "urgentSignals",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  (v57/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "breadcrumbs",
                    "storageKey": null
                  },
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "descriptionImages",
                    "plural": true,
                    "selections": (v34/*: any*/),
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategoryTeam",
                "kind": "LinkedField",
                "name": "defaultTodoCategory",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v53/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "allTodos",
                    "args": null,
                    "concreteType": "TodoConnection",
                    "kind": "LinkedField",
                    "name": "todos",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v58/*: any*/),
                    "concreteType": "TodoConnection",
                    "kind": "LinkedField",
                    "name": "todos",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TodoEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Todo",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ordinal",
                                "storageKey": null
                              },
                              (v59/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "response",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v60/*: any*/)
                                    ],
                                    "type": "TodoResponseImage",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "canWrite",
                                "storageKey": null
                              },
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "body",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "formattedBody",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "canChangeStatus",
                                "storageKey": null
                              },
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isIssue",
                                "storageKey": null
                              },
                              (v57/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TodoContact",
                                "kind": "LinkedField",
                                "name": "contact",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "phoneNumber",
                                    "storageKey": null
                                  },
                                  (v61/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "feedbackStatus",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AssignedEmployee",
                                "kind": "LinkedField",
                                "name": "assigned",
                                "plural": true,
                                "selections": [
                                  (v36/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Employee",
                                    "kind": "LinkedField",
                                    "name": "employee",
                                    "plural": false,
                                    "selections": (v39/*: any*/),
                                    "storageKey": null
                                  },
                                  (v11/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AssignedRole",
                                "kind": "LinkedField",
                                "name": "assignedRoles",
                                "plural": true,
                                "selections": [
                                  (v40/*: any*/),
                                  (v11/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoreZonedDate",
                                "kind": "LinkedField",
                                "name": "expireAtDate",
                                "plural": false,
                                "selections": [
                                  (v62/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isoString",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TodoCategoryTag",
                                "kind": "LinkedField",
                                "name": "tags",
                                "plural": true,
                                "selections": [
                                  (v11/*: any*/),
                                  (v16/*: any*/),
                                  (v13/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoreProduct",
                                "kind": "LinkedField",
                                "name": "linkedProducts",
                                "plural": true,
                                "selections": [
                                  (v12/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "imageUrl",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Todo",
                                "kind": "LinkedField",
                                "name": "subTodos",
                                "plural": true,
                                "selections": [
                                  (v59/*: any*/),
                                  (v11/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "commentCount",
                                "storageKey": null
                              },
                              (v45/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isResponseCompleted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoreZonedDate",
                                "kind": "LinkedField",
                                "name": "resolvedAtDate",
                                "plural": false,
                                "selections": (v63/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "lastChangedStatusByActor",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v64/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StoreUser",
                                        "kind": "LinkedField",
                                        "name": "storeUser",
                                        "plural": false,
                                        "selections": [
                                          (v65/*: any*/),
                                          (v67/*: any*/),
                                          (v11/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "UserActor",
                                    "abstractKey": null
                                  },
                                  (v68/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v69/*: any*/),
                                    "type": "GroupActor",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v69/*: any*/),
                                    "type": "ConnectActor",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v60/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoreZonedDate",
                                "kind": "LinkedField",
                                "name": "createdAtDate",
                                "plural": false,
                                "selections": (v63/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "timeToResolvedFormatted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TodoSubject",
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TodoSubjectBreadcrumb",
                                    "kind": "LinkedField",
                                    "name": "allBreadcrumbs",
                                    "plural": true,
                                    "selections": [
                                      (v13/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "requiredToDescribeTodo",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v55/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "iconUri",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "createdByActor",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v64/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StoreUser",
                                        "kind": "LinkedField",
                                        "name": "storeUser",
                                        "plural": false,
                                        "selections": [
                                          (v70/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                              (v12/*: any*/),
                                              (v61/*: any*/),
                                              (v11/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "OrgDescription",
                                                "kind": "LinkedField",
                                                "name": "orgDescription",
                                                "plural": false,
                                                "selections": [
                                                  (v29/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v11/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "UserActor",
                                    "abstractKey": null
                                  },
                                  (v68/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Employee",
                                        "kind": "LinkedField",
                                        "name": "employee",
                                        "plural": false,
                                        "selections": [
                                          (v12/*: any*/),
                                          (v11/*: any*/),
                                          (v6/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v71/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": (v51/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "GroupActor",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v71/*: any*/),
                                      (v70/*: any*/)
                                    ],
                                    "type": "ConnectActor",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__id",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v58/*: any*/),
                    "filters": [
                      "status",
                      "includeNewlyCompleted"
                    ],
                    "handle": "connection",
                    "key": "TeamDefaultTodoCategory_todos",
                    "kind": "LinkedHandle",
                    "name": "todos"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "condition": "isEmployee",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "Employee",
                "kind": "LinkedField",
                "name": "employee",
                "plural": false,
                "selections": (v72/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isEmployee",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreUser",
                "kind": "LinkedField",
                "name": "me",
                "plural": false,
                "selections": [
                  (v67/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Employee",
                    "kind": "LinkedField",
                    "name": "employee",
                    "plural": false,
                    "selections": (v72/*: any*/),
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1cca23aea945f8c1640334ed8104c7a3",
    "id": null,
    "metadata": {},
    "name": "TeamQuery",
    "operationKind": "query",
    "text": "query TeamQuery(\n  $teamId: ID!\n  $first: Int\n  $after: String\n  $status: TodoStatus\n  $employeeId: ID\n  $isEmployee: Boolean!\n) {\n  viewer {\n    appInfo {\n      ...TeamAppInfoButton_appInfo\n      __typename\n    }\n  }\n  store {\n    myRole\n    ...usePermissions_store\n    employee(id: $employeeId) @include(if: $isEmployee) {\n      ...Avatar_employee\n      id\n    }\n    me @skip(if: $isEmployee) {\n      user {\n        ...Avatar_user\n        id\n      }\n      employee {\n        ...Avatar_employee\n        id\n      }\n      id\n    }\n    team(id: $teamId) {\n      id\n      name\n      ...TeamTeamSchedule_team\n      ...TeamTeamSchedulePreview_team\n      ...TeamFeatureBar_team\n      ...TeamUrgentSignals_team\n      urgentSignals {\n        __typename\n        id\n      }\n      defaultTodoCategory {\n        ...TeamDefaultTodoCategory_TodoCategoryTeam\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment AHImageStackComponent_Images on Image {\n  id\n  ...Image_image\n}\n\nfragment Avatar_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        ...Avatar_employee\n        id\n      }\n      user {\n        name\n        ...Avatar_user\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    ...Avatar_groupActor\n  }\n  ... on ConnectActor {\n    __typename\n    ...Avatar_connectActor\n  }\n}\n\nfragment Avatar_connectActor on ConnectActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment Avatar_groupActor on GroupActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_user on User {\n  name\n}\n\nfragment CreatedBySubject_actor on Actor {\n  __isActor: __typename\n  ...SignedActorCompact_actor\n}\n\nfragment DescriptionContentFiles_files on File {\n  id\n  url\n  ...FileCollectionItem_File\n}\n\nfragment DescriptionContentMedia_Media on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  __typename\n}\n\nfragment FileCollectionItem_File on File {\n  name\n  id\n  url\n  type\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment ListItemAssignees_employees on Employee {\n  id\n  ...ListItemEmployees_employees\n}\n\nfragment ListItemAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment ListItemEmployees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ListItemRoles_roles on EmployeeRole {\n  id\n  name\n  isLinkedToViewer\n  employeeIds\n  team {\n    id\n  }\n  employees {\n    id\n    name\n    isLinkedToViewer\n    workStatus\n    ...Avatar_employee\n  }\n}\n\nfragment RoutineOccasionDescriptionContent_Routine on Routine {\n  descriptionImages {\n    ...DescriptionContentMedia_Media\n    id\n  }\n  description\n  descriptionFiles {\n    ...DescriptionContentFiles_files\n    id\n  }\n}\n\nfragment RoutineOccasionListItemAssignedEmployees_RoutineOccasion on RoutineOccasion {\n  assigned {\n    id\n    employee {\n      id\n      isLinkedToViewer\n      ...ListItemAssignees_employees\n    }\n    assignedAt\n  }\n  assignedRoles {\n    role {\n      ...ListItemAssignees_roles\n      id\n    }\n    id\n  }\n}\n\nfragment RoutineOccasionScreenRoutineDescription_Routine on Routine {\n  title\n  isOrg\n  ...RoutineOccasionDescriptionContent_Routine\n}\n\nfragment RoutineOccasionStatusCircleInline_RoutineOccasion on RoutineOccasion {\n  id\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  deadlineAt\n  startAt\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment SignalListItem_signal on Signal {\n  id\n  priority\n  title\n  breadcrumbs\n  orgIconUri\n  descriptionImages {\n    ...AHImageStackComponent_Images\n    id\n  }\n}\n\nfragment SignedActorCompactBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n  }\n  ... on ConnectActor {\n    __typename\n  }\n}\n\nfragment SignedActorCompact_actor on Actor {\n  __isActor: __typename\n  ...SignedActorText_actor\n  ...SignedActorCompactBadge_actor\n}\n\nfragment SignedActorText_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        id\n      }\n      user {\n        name\n        email\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      name\n      id\n    }\n    identifyingName\n  }\n  ... on ConnectActor {\n    __typename\n    identifyingName\n    employee {\n      name\n      id\n    }\n  }\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment StoreFormattedDate_1b2lNL on StoreZonedDate {\n  storeFormattedDate(style: TIME_ONLY)\n}\n\nfragment TeamAppInfoButton_appInfo on AppInfo {\n  title\n  description\n  linkURL\n  type\n}\n\nfragment TeamDefaultTodoCategory_TodoCategoryTeam on TodoCategoryTeam {\n  id\n  notResolvedCount\n  team {\n    id\n    color\n  }\n  category {\n    id\n    title\n  }\n  allTodos: todos {\n    totalCount\n  }\n  ...TeamDefaultTodoCategory_TodoCategoryTeamPager\n}\n\nfragment TeamDefaultTodoCategory_TodoCategoryTeamPager on TodoCategoryTeam {\n  id\n  todos(first: $first, after: $after, status: $status, includeNewlyCompleted: true) {\n    edges {\n      node {\n        id\n        ordinal\n        ...TodoListItem_todo\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TeamFeatureBarKPIItem_KPITeamFeature on KPITeamFeature {\n  KPIRoutines {\n    occasions(first: 1) {\n      edges {\n        node {\n          occasionSections(teamId: $teamId) {\n            id\n            taskExecutions {\n              __typename\n              ... on TaskExecutionNumber {\n                isCompleted\n              }\n              id\n            }\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature on ProductDateTrackerTeamFeature {\n  id\n  hasExpiredBatches\n  hasPendingActions\n}\n\nfragment TeamFeatureBarSignalItem_team on SignalTeamFeature {\n  unreadCount\n  activeCount\n  signalUnreadCount(employeeId: $employeeId)\n  hasHighPrioritySignals\n}\n\nfragment TeamFeatureBarTodoCategoryItem_todoCategoryTeam on TodoCategoryTeam {\n  id\n  notResolvedCount\n  todoActiveAssignedCount(employeeId: $employeeId)\n  hasExpiredTodos\n  todoHighestPrio\n  category {\n    id\n    title\n    icon\n  }\n}\n\nfragment TeamFeatureBar_team on Team {\n  id\n  features {\n    __typename\n    ... on TodoCategoryTeamFeature {\n      id\n      todoCategoryTeam {\n        ...TeamFeatureBarTodoCategoryItem_todoCategoryTeam\n        id\n      }\n      __typename\n    }\n    ... on FileTeamFeature {\n      __typename\n    }\n    ... on SignalTeamFeature {\n      __typename\n      ...TeamFeatureBarSignalItem_team @defer(label: \"TeamFeatureBar_team$defer$TeamFeatureBarSignalItem_team\")\n    }\n    ... on CalendarTeamFeature {\n      __typename\n    }\n    ... on KPITeamFeature {\n      ...TeamFeatureBarKPIItem_KPITeamFeature\n      __typename\n    }\n    ... on ProductTeamFeature {\n      __typename\n    }\n    ... on ProductDateTrackerTeamFeature {\n      ...TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature @defer(label: \"TeamFeatureBar_team$defer$TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature\")\n      __typename\n    }\n    ... on EmployeeScheduleTeamFeature {\n      __typename\n    }\n    id\n  }\n}\n\nfragment TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion on TeamScheduleInlineRoutineOccasion {\n  id\n  startAt\n  taskExecution {\n    id\n    task {\n      id\n    }\n    sectionId\n    routineOccasion {\n      id\n      store {\n        myRole\n        id\n      }\n      sequenceNumber\n      notDoneStatus\n      completedTaskExecutionCount\n      totalTaskExecutionCount\n      status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n      ...RoutineOccasionStatusCircleInline_RoutineOccasion\n      ...TeamScheduleRoutineListItemContent_RoutineOccasion\n      ...TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion\n      ...TeamScheduleListItemScheduleRange_routineOccasion\n    }\n    routine {\n      ...TeamScheduleRoutineListItemContent_Routine\n      id\n    }\n    checkValue\n  }\n}\n\nfragment TeamScheduleListItemMonthlyRange_routineOccasion on ScheduledOccasion {\n  __isScheduledOccasion: __typename\n  startAt\n  deadlineAt\n}\n\nfragment TeamScheduleListItemScheduleRange_routineOccasion on ScheduledOccasion {\n  __isScheduledOccasion: __typename\n  ...TeamScheduleListItemWeeklyRange_routineOccasion\n  ...TeamScheduleListItemMonthlyRange_routineOccasion\n}\n\nfragment TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  __typename\n  ... on RoutineOccasion {\n    startAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n    deadlineAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n  }\n  ... on TeamScheduleInlineRoutineOccasion {\n    taskExecution {\n      routineOccasion {\n        startAtDate {\n          ...StoreFormattedDate_1b2lNL\n        }\n        deadlineAtDate {\n          ...StoreFormattedDate_1b2lNL\n        }\n        id\n      }\n      id\n    }\n  }\n  ... on TeamScheduleOneOffEvent {\n    startAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n    endAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n  }\n}\n\nfragment TeamScheduleListItemWeeklyRange_routineOccasion on ScheduledOccasion {\n  __isScheduledOccasion: __typename\n  startAt\n  deadlineAt\n}\n\nfragment TeamScheduleListItem_TeamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  __typename\n  ...TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion\n  ... on RoutineOccasion {\n    ...TeamScheduleRoutineOccasionListItem_RoutineOccasion\n    routine {\n      id\n      isArchived\n      ...RoutineOccasionScreenRoutineDescription_Routine\n    }\n  }\n  ... on TeamScheduleInlineRoutineOccasion {\n    ...TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion\n  }\n}\n\nfragment TeamScheduleRoutineListItemContent_Routine on Routine {\n  id\n  title\n  isOrg\n  description\n  orgIconUri\n  isArchived\n  ...RoutineOccasionScreenRoutineDescription_Routine\n  descriptionImages {\n    ...AHImageStackComponent_Images\n    id\n  }\n}\n\nfragment TeamScheduleRoutineListItemContent_RoutineOccasion on RoutineOccasion {\n  assigned {\n    employee {\n      id\n    }\n    id\n  }\n  assignedRoles {\n    role {\n      id\n    }\n    id\n  }\n  ...RoutineOccasionListItemAssignedEmployees_RoutineOccasion\n}\n\nfragment TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion on RoutineOccasion {\n  issueCount\n}\n\nfragment TeamScheduleRoutineOccasionListItem_RoutineOccasion on RoutineOccasion {\n  ...RoutineOccasionStatusCircle_RoutineOccasion\n  ...TeamScheduleRoutineListItemContent_RoutineOccasion\n  ...TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion\n  ...TeamScheduleListItemScheduleRange_routineOccasion\n  sequenceNumber\n  completedTaskExecutionCount\n  totalTaskExecutionCount\n  routine {\n    id\n    ...TeamScheduleRoutineListItemContent_Routine\n  }\n}\n\nfragment TeamScheduleSectionHeaderStatusDot_routineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  totalTaskExecutionCount\n}\n\nfragment TeamScheduleSectionHeaderSummaryOccasions_teamSchedule on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  ...TeamScheduleSectionHeaderStatusDot_routineOccasion\n}\n\nfragment TeamScheduleSectionHeaderSummary_teamSchedule on TeamSchedule {\n  id\n  events(includeInlineRoutines: true) {\n    __typename\n    ... on RoutineOccasion {\n      __typename\n      ...TeamScheduleSectionHeaderSummaryOccasions_teamSchedule\n    }\n    ... on TeamScheduleInlineRoutineOccasion {\n      __typename\n      taskExecution {\n        routineOccasion {\n          ...TeamScheduleSectionHeaderSummaryOccasions_teamSchedule\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment TeamTeamSchedulePreview_team on Team {\n  id\n  color\n  dailySchedule: currentTeamSchedule(freq: DAILY) {\n    ...TeamScheduleSectionHeaderSummary_teamSchedule\n    events(includeInlineRoutines: true) {\n      startAt\n      id\n      __typename\n      ... on RoutineOccasion {\n        routine {\n          description\n          descriptionImages {\n            __typename\n            id\n          }\n          id\n        }\n        assigned {\n          id\n        }\n        assignedRoles {\n          id\n        }\n      }\n      ... on TeamScheduleInlineRoutineOccasion {\n        taskExecution {\n          routineOccasion {\n            routine {\n              description\n              descriptionImages {\n                __typename\n                id\n              }\n              id\n            }\n            assigned {\n              id\n            }\n            assignedRoles {\n              id\n            }\n            id\n          }\n          id\n        }\n      }\n      ...TeamScheduleListItem_TeamScheduleEventOccasion\n    }\n    id\n  }\n  weeklySchedule: currentTeamSchedule(freq: WEEKLY) {\n    ...TeamScheduleSectionHeaderSummary_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n    }\n    id\n  }\n  monthlySchedule: currentTeamSchedule(freq: MONTHLY) {\n    ...TeamScheduleSectionHeaderSummary_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n    }\n    id\n  }\n}\n\nfragment TeamTeamSchedule_team on Team {\n  id\n  color\n  dailySchedule: currentTeamSchedule(freq: DAILY) {\n    id\n    isActive\n  }\n  weeklySchedule: currentTeamSchedule(freq: WEEKLY) {\n    id\n    isActive\n  }\n  monthlySchedule: currentTeamSchedule(freq: MONTHLY) {\n    id\n    isActive\n  }\n}\n\nfragment TeamUrgentSignals_team on Team {\n  store {\n    activeSignalCount\n    hasHighPrioritySignals\n    unreadSignalCount\n    id\n  }\n  urgentSignals {\n    id\n    ...SignalListItem_signal\n  }\n}\n\nfragment TodoCircleStatusWithResponse_todo on Todo {\n  id\n  expireAt\n  status\n  canChangeStatus\n  canWrite\n  ordinal\n  isResponseCompleted\n  response {\n    __typename\n    ... on TodoResponseNumber {\n      __typename\n    }\n    ... on TodoResponseImage {\n      __typename\n      images {\n        id\n        ...Image_image\n      }\n    }\n    ... on TodoResponseText {\n      __typename\n    }\n  }\n}\n\nfragment TodoListItemAssignedUsers_todo on Todo {\n  assigned {\n    assignedAt\n    employee {\n      id\n      ...ListItemAssignees_employees\n    }\n    id\n  }\n  assignedRoles {\n    role {\n      id\n      ...ListItemAssignees_roles\n    }\n    id\n  }\n}\n\nfragment TodoListItemCompletedInfo_todo on Todo {\n  resolvedAtDate {\n    ...StoreFormattedDate\n  }\n  lastChangedStatusByActor {\n    __typename\n    ...Avatar_actor\n  }\n}\n\nfragment TodoListItemContact_todo on Todo {\n  contact {\n    name\n    phoneNumber\n    email\n  }\n  feedbackStatus\n}\n\nfragment TodoListItemFooterDone_todo on Todo {\n  ...TodoListItemContact_todo\n  feedbackStatus\n  contact {\n    __typename\n  }\n}\n\nfragment TodoListItemFooterPending_todo on Todo {\n  ...TodoListItemAssignedUsers_todo\n  ...TodoListItemContact_todo\n  feedbackStatus\n  contact {\n    __typename\n  }\n  expireAtDate {\n    ...StoreFormattedDate\n    isoString\n  }\n  tags {\n    ...TodoListItemTags_tag\n  }\n  assigned {\n    __typename\n    id\n  }\n  assignedRoles {\n    __typename\n    id\n  }\n  linkedProducts {\n    ...TodoListItemProducts_StoreProduct\n    id\n  }\n  ...TodoListItemFooterSubTodos_todo\n  subTodos {\n    __typename\n    id\n  }\n  commentCount\n}\n\nfragment TodoListItemFooterSubTodos_todo on Todo {\n  id\n  subTodos {\n    status\n    id\n  }\n}\n\nfragment TodoListItemFooter_todo on Todo {\n  ...TodoListItemFooterDone_todo\n  ...TodoListItemFooterPending_todo\n  status\n}\n\nfragment TodoListItemHeaderWrapper_todo on Todo {\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  timeToResolvedFormatted\n}\n\nfragment TodoListItemHeader_todo on Todo {\n  ...TodoListItemHeaderWrapper_todo\n  subject {\n    ...TodoSubject_TodoSubject\n  }\n  title\n  isIssue\n  createdByActor {\n    __typename\n    ...CreatedBySubject_actor\n  }\n}\n\nfragment TodoListItemMainContentDetails_todo on Todo {\n  ...TodoListItemCompletedInfo_todo\n  status\n  images {\n    id\n    ...Image_image\n  }\n  linkedProducts {\n    imageUrl\n    id\n  }\n}\n\nfragment TodoListItemMainContentText_todo on Todo {\n  title\n  isIssue\n  status\n}\n\nfragment TodoListItemPriority_todo on Todo {\n  priority\n  status\n}\n\nfragment TodoListItemProducts_StoreProduct on StoreProduct {\n  name\n}\n\nfragment TodoListItemTags_tag on TodoCategoryTag {\n  id\n  color\n  title\n}\n\nfragment TodoListItem_todo on Todo {\n  id\n  status\n  ordinal\n  response {\n    __typename\n  }\n  canWrite\n  isOrg\n  body\n  formattedBody\n  canChangeStatus\n  ...TodoListItemMainContentText_todo\n  ...TodoListItemPriority_todo\n  ...TodoListItemFooter_todo\n  ...TodoCircleStatusWithResponse_todo\n  ...TodoListItemMainContentDetails_todo\n  ...TodoListItemHeader_todo\n}\n\nfragment TodoSubjectIcon_TodoSubject on TodoSubject {\n  icon\n  iconUri\n}\n\nfragment TodoSubject_TodoSubject on TodoSubject {\n  allBreadcrumbs {\n    title\n    requiredToDescribeTodo\n  }\n  ...TodoSubjectIcon_TodoSubject\n}\n\nfragment usePermissions_store on Store {\n  id\n  myPermissions\n}\n"
  }
};
})();

(node as any).hash = "b65bf06dd144624472d82a69ef6bd9f8";

export default node;
